import { useMemo } from "react";
import { useVisibleSizeAtZDepth } from "@utils/visibleSizeAtZDepth";

export default () => {
  const { width, height } = useVisibleSizeAtZDepth(0);
  return useMemo(() => (Math.max(width, height) / 2) * 1.6, [width, height]);
};
